import { createTheme } from '@mui/material';
import typography from './typography';
import {colors} from '../styles/colors';

// глобальная тема приложения
// используется в компоненте ThemeProvider
// для стилизации компонентов Material UI
const theme = createTheme({
  palette: {
    primary: {
      main: colors.elements,
    },
    info: {
      main: "#e3f2fd",
    },
    text: {
      primary: colors.font_primary,
    }
  },
  typography
});

export default theme;
